/**
 * User Routes (Regular Customers)
 * 
 * Routes for authenticated regular users managing their events, payments, etc.
 */

export const USER_ROUTES = {
  /**
   * Events dashboard - locale-aware
   */
  events: (locale: string) => locale === "ro" 
    ? `/${locale}/evenimente`
    : `/${locale}/events`,

  /**
   * Event detail/management - locale-aware
   * Uses hyphenated route to avoid conflict with public event routes
   */
  event: (locale: string, eventId: string) => locale === "ro"
    ? `/${locale}/editeaza-eveniment/${eventId}`
    : `/${locale}/edit-event/${eventId}`,

  /**
   * JUB-154: event creation wizard. Without a uuid it is the entry screen;
   * with one, the step lives in the URL so Back works and a reload resumes.
   */
  onboarding: (locale: string, eventId?: string, step?: string) => {
    const base = locale === "ro" ? `/${locale}/eveniment-nou` : `/${locale}/new-event`;
    return eventId ? `${base}/${eventId}/${step ?? "people"}` : base;
  },

  /**
   * Payment settings - locale-aware
   */
  payments: (locale: string) => locale === "ro"
    ? `/${locale}/plati`
    : `/${locale}/payments`,

  /**
   * Packages/pricing page
   */
  packages: (locale: string) => `/${locale}/pachete`,

  /**
   * Stripe Connected Accounts - Connect Stripe account to receive payments
   */
  connectedAccounts: (locale: string) => locale === "ro"
    ? `/${locale}/conturi-conectate`
    : `/${locale}/connected-accounts`,

  /**
   * Account Settings - User preferences and settings
   */
  settings: (locale: string) => locale === "ro"
    ? `/${locale}/setari`
    : `/${locale}/settings`,
} as const;

